/**
 * API Client for Article Creator
 *
 * Uses the shared API client from the parent app via Module Federation.
 * This ensures consistent authentication and request handling across all apps.
 */

// Import shared API client from parent app via Module Federation
import { api, getApiBaseUrl } from 'shell/Api';
import type { ApiResponse } from 'shell/Api';

// Re-export the shared API client and types
export { api, getApiBaseUrl };
export type { ApiResponse };

export default api;
